import React from "react";
import { Button } from "@plum-xoxo/admin-dsm";
import { XoxodayLongLogo } from "./Icons";
import config from "config";
const url = config.storeFrontUrl.replace(/\/$/g, "");

const MobileLanding = () => {
  return (
    <div className="landing-css text-center">
      <div className="d-flex justify-content-center mb-4">
        <XoxodayLongLogo width="120" height="32" />
      </div>
      <h4 className="text-header">
        Xoxoday Plum Admin
        <br /> portal works best in web
        <br />
        browsers.
      </h4>
      <Button
        onClick={() => window.open("https://www.xoxoday.com/book-a-demo")}
        color="primary"
        shade="c02"
        className="mb-16"
      >
        Book a demo
      </Button>
      <div style={{ textAlign: "center" }} className="mb-4">
        <a
          className="w-100 link-color"
          href="https://www.xoxoday.com/company/contact-us"
        >
          Contact us
        </a>
      </div>
      <hr className="mt-0 mb-4" />
      <p className="w-100" style={{ textAlign: "center" }}>
        Looking to redeem rewards?
      </p>
      <div style={{ textAlign: "center" }}>
        <a
          href={url + "/marketplace/vouchers"}
          className="w-100 -info"
          style={{ textDecoration: "underline" }}
        >
          Go to stores
        </a>
      </div>
    </div>
  );
};

export default MobileLanding;
